module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "order content",
    staticStyle: {
      "display": "block"
    }
  }, [_c('pkHeader', {
    attrs: {
      "headerTitle": _vm.title,
      "rightContentProps": false,
      "backmethod": _vm.goback
    }
  }), _vm._v(" "), _c('div', {
    ref: "infinite",
    staticClass: "container infinite-scroll"
  }, [(_vm.records.length == 0) ? _c('div', {
    staticClass: "order_null"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/img_norder.png")
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#494949"
    }
  }, [_vm._v("订购方式:")]), _vm._v(" "), _c('p', [_vm._v("在移动端首页点击“接送专车”预约您的行程")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "btn_call"
  }, [_c('a', {
    on: {
      "click": _vm.toCall
    }
  }, [_vm._v("去叫车")])])])]) : _vm._e()]), _vm._v(" "), _c('scroll', {
    ref: "listview",
    staticClass: "listview order_conc",
    style: ({
      height: _vm.docHeigh + 'px'
    }),
    attrs: {
      "listen-scroll": _vm.listenScroll,
      "probe-type": _vm.probeType,
      "data": [_vm.n],
      "pulldown": _vm.pulldown,
      "pullup": _vm.pullup
    },
    on: {
      "pulldown": function($event) {
        _vm.loadPage(1)
      },
      "scroll": _vm.loadData
    }
  }, [_c('div', [_vm._l((_vm.records), function(item, index) {
    return [_c('group', {
      staticClass: "order_cont",
      nativeOn: {
        "click": function($event) {
          _vm.routerTo(item.orderNo, item.bizType)
        }
      }
    }, [_c('cell', {
      attrs: {
        "title": item.bookDate + ' ' + item.dirverTime
      }
    }, [_c('div', {
      attrs: {
        "slot": "value"
      },
      slot: "value"
    }, [_c('span', {
      style: ({
        color: item.activeColor
      })
    }, [_vm._v(_vm._s(_vm.updateOrder(index, item.orderState, item.carInfo)))])])]), _vm._v(" "), _c('div', {
      staticClass: "weui-cell vux-cell-form-preview vux-cell-no-border-intent",
      staticStyle: {
        "padding": "16px 15px"
      }
    }, [_c('div', {
      staticClass: "item-title label custom newlist"
    }, [_c('p', {
      staticStyle: {
        "padding-bottom": "1.2rem"
      }
    }, [_vm._v(_vm._s(item.upSiteName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.downSiteName))])])])], 1)]
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "noMore"
  }, [_vm._v("没有更多数据")])], 2)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe3a0b0c"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/list.vue
// module id = 428
// module chunks = 1